/**
 * @generated SignedSource<<973a166eaf40e21c7f25be3d1468346a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsForceConfigurationMutation$variables = {
  id: string;
};
export type MutationsForceConfigurationMutation$data = {
  readonly forceConfiguration: boolean;
};
export type MutationsForceConfigurationMutation = {
  response: MutationsForceConfigurationMutation$data;
  variables: MutationsForceConfigurationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "forceConfiguration",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsForceConfigurationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsForceConfigurationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1be72e4dad0994baf08a5c80e14c1af4",
    "id": null,
    "metadata": {},
    "name": "MutationsForceConfigurationMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsForceConfigurationMutation(\n  $id: ID!\n) {\n  forceConfiguration(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "31c58bd7f970fecf8b21a6077ee5d681";

export default node;
